import React from "react";
import OtpContainer from "../components/Otp/OtpContainer";

type Props = {};

const Otp = (props: Props) => {
  return (
    <div className="page">
      <OtpContainer />
    </div>
  );
};

export default Otp;
